"use client";
import * as React from 'react';
import { wrapper, item, link } from './styles.js';
import { useMenuApi } from '../../utils/hooks/useMenuApi.web.js';
import { IconButton } from '../../IconButton/IconButton.web.js';
import { MenuModal } from './MenuModal/MenuModal.web.js';
import { IconMenu } from '../../icons/ui_general/IconMenu.web.js';
import { ThemeProvider } from 'styled-components';
import { colors } from '../../constants/colors.js';
import { useBoolean } from '../../utils/hooks/useBoolean.js';
import { useTheme } from '../../utils/theming/useTheme.js';
import { Hidden } from '../../Hidden/Hidden.web.js';

/**
 * @deprecated -- Please do not use this component. It is deprecated and will be removed in the future is no longer receiving updates.
 */
var MenuWidget = function MenuWidget(_ref) {
  var _ref$dataURL = _ref.dataURL,
    dataURL = _ref$dataURL === undefined ? 'https://www.fortum.fi/api/v1/menu/main?_format=json' : _ref$dataURL,
    _ref$placeholderCount = _ref.placeholderCount,
    placeholderCount = _ref$placeholderCount === undefined ? 3 : _ref$placeholderCount,
    _ref$foregroundColor = _ref.foregroundColor,
    foregroundColor = _ref$foregroundColor === undefined ? colors.inkGrey : _ref$foregroundColor,
    _ref$hoverColor = _ref.hoverColor,
    hoverColor = _ref$hoverColor === undefined ? colors.oceanGreen : _ref$hoverColor,
    _ref$highlightColor = _ref.highlightColor,
    highlightColor = _ref$highlightColor === undefined ? colors.oceanGreen : _ref$highlightColor,
    _ref$appendToHref = _ref.appendToHref,
    appendToHref = _ref$appendToHref === undefined ? '' : _ref$appendToHref,
    _ref$modalOpen = _ref.modalOpen,
    modalOpen = _ref$modalOpen === undefined ? false : _ref$modalOpen;
  var _useBoolean = useBoolean(modalOpen),
    modalOpenState = _useBoolean.value,
    closeModal = _useBoolean.setFalse,
    toggleModal = _useBoolean.toggle;
  var _useMenuApi = useMenuApi(dataURL),
    data = _useMenuApi.data,
    loading = _useMenuApi.loading;
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Hidden, {
    below: "l"
  }, /*#__PURE__*/React.createElement(wrapper, {
    "data-testid": "elemental-MenuWidget-desktop"
  }, loading ? null : data.map(function (item$1) {
    return /*#__PURE__*/React.createElement(item, {
      key: item$1.key
    }, /*#__PURE__*/React.createElement(link, {
      href: "".concat(item$1.absolute).concat(appendToHref),
      $foregroundColor: foregroundColor,
      $hoverColor: hoverColor
    }, item$1.title));
  }))), /*#__PURE__*/React.createElement(Hidden, {
    above: "l",
    "data-testid": "elemental-MenuWidget-mobile"
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(IconMenu, {
      size: 24
    }),
    "data-testid": "hamburger-menu-open",
    color: highlightColor,
    status: "plain",
    size: 48,
    onClick: toggleModal,
    "aria-label": "Open hamburger menu"
  }), /*#__PURE__*/React.createElement(MenuModal, {
    onClose: closeModal,
    menuItems: data,
    appendToHref: appendToHref,
    loading: loading,
    opened: modalOpenState,
    placeholderCount: placeholderCount
  })));
};

export { MenuWidget };
